export default {"src":"/_next/static/media/torus.0bbfc26d.svg","height":28,"width":28};